<template>
  <div>
    <template v-if="isFreeSubscriptionActive && !isBlueBlockActive">
      <div style="background: #31AAE1;min-height:100px;min-width: 100px;"></div>
    </template>
    <template v-else>
      <div v-if="!fetching" id="business-stats-widget">
        <div class="rating-stars-container">
          <rating :stars="getRoundedStars" :business-stats-widget="tinyStars"></rating>
        </div>
        <img src="/static/img/logo/hellopeter-logo.png" srcset="/static/img/logo/hellopeter-logo@2x.png 2x"
             alt="Hellopeter.com">
        <div class="left-block">
          <span v-if="renderReviews || canRenderReviews" class="counter" v-text="reviews"></span><span
          v-if="renderReviews || canRenderReviews">Total Reviews</span>
          <span v-if="renderRating || canRenderRating" class="counter" v-text="rating"></span><span
          v-if="renderRating || canRenderRating">Avg Rating</span>
          <span v-if="(renderTrustIndex || canRenderTrustIndex) && !hideTrustIndex" class="counter"
                v-text="trustIndex"></span><span v-if="(renderTrustIndex || canRenderTrustIndex ) && !hideTrustIndex">TrustIndex</span>
          <span v-if="renderIndustrRanking || canRenderIndustrRanking" class="counter"
                v-text="industryRankNumber"></span><span v-if="renderIndustrRanking || canRenderIndustrRanking"
                                                         v-text="industryRankText"></span>
        </div>
      </div>
      <img v-if="fetching" class="stats-loader" src="/static/img/loaders/spinner.svg" alt="fetching Business stats..."/>
    </template>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import qs from 'qs'
  import axios from 'axios'
  import Rating from './../components/Rating.vue'
  import misc from './../mixins/misc.js'

  export default {
    name: 'BusinessStatsWidget',
    mixins: [misc],
    components: {
      Rating
    },
    props: {
      slug: {
        type: String
      },
      renderReviews: {
        type: Boolean,
        default: false
      },
      renderRating: {
        type: Boolean,
        default: false
      },
      renderTrustIndex: {
        type: Boolean,
        default: false
      },
      renderIndustrRanking: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        fetching: false,
        reviews: 0,
        rating: 0,
        trustIndex: 0,
        industryRank: 0,
        industryCategory: '',
        tinyStars: true,
        hideTrustIndex: false
      }
    },
    computed: {
      getRoundedStars () {
        return Math.max(Math.floor(this.rating), 1)
      },
      industryRankText () {
        return `in ${this.industryCategory}`
      },
      industryRankNumber () {
        return `#${this.industryRank}`
      },
      canRenderReviews () {
        return !!this.$route.query.reviews
      },
      canRenderRating () {
        return !!this.$route.query.rating
      },
      canRenderTrustIndex () {
        return !!this.$route.query.trust_index
      },
      canRenderIndustrRanking () {
        return !!this.$route.query.industry_ranking
      }
    },
    created () {
      this.getBusinessStats()
      this.getCurrentBusinessActiveSubscription()
    },
    methods: {
      getBusinessStats () {
        this.fetching = true
        const widgetTracking = qs.stringify({
          track_activity_action: 'business.stats.view',
          track_activity_event: 'WidgetActivity'
        })
        axios.get(`/widgets/${this.slug}/business-stats?${widgetTracking}`)
          .then(({data}) => {
            if (data.reviews < 10) {
              // we need not to display trustIndex if business has lesser than 10 reviews
              this.hideTrustIndex = true
            }
            this.reviews = data.reviews || 756
            this.rating = data.rating || 4.8
            this.trustIndex = data.trustIndex || 9.2
            this.industryRank = data.industryRank
            this.industryCategory = data.industryCategory
            this.fetching = false
          })
      }
    }
  }
</script>
<style>
  #business-stats-widget {
    width: 504px;
    overflow: hidden;
    margin: 0;
    padding: 10px 0 5px 10px;
    font-size: 0.75rem;
  }

  #business-stats-widget > .left-block {
    width: 313px;
    color: #58595B;
    clear: both;
    margin: 0px auto;
    display: block;
    text-align: center;
}

  #business-stats-widget > .left-block > span {
    height: 0.75rem;
  }

  #business-stats-widget > .left-block > .counter {
    color: #30AAE1;
    font-weight: bold;
  }

  #business-stats-widget > .left-block > span:nth-child(even) {
    padding-left: 3px;
    padding-right: 5px;
    border-right: 1px solid #58595B;
    margin-right: 3px;
  }

  #business-stats-widget > .left-block > span:last-child {
    padding-right: 0;
    margin-right: 0;
    border: none;
  }

  #business-stats-widget img {
    width: 85px;
    display: block;
    float: left;
    margin-top: 5px;
    margin-left: 5px;
    margin-right: 10px;
  }

  .rating-stars-container {
    display: block;
    float: left;
    padding-left: 5px;
    padding-bottom: 6px;
  }

  img.stats-loader {
    width: 40px;
    height: 40px;
    float: none;
    display: block;
    margin: auto;
  }

  #business-stats-widget img {
    width: 85px;
    display: block;
    float: left;
    margin-top: 5px;
    margin-left: 5px;
    margin-right: 10px;
  }

  #business-stats-widget img {
    width: 85px !important;
    float: right !important;
    margin-top: 10px;
    margin-left: 2px !important;
  }

  #business-stats-widget {
    width: 402px !important;
  }
</style>



// WEBPACK FOOTER //
// src/widgets/BusinessStatsWidget.vue